import { Patientallergy, PatientAllergyControllerApi } from "../../services";
import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

/**
 * @author Rajkumar Rathod
 */
export const usePatientAllergiesCreate = () =>
  useMutationWithLoading(
    async (params: { patientAllergy: Patientallergy; xTENANTID?: string }) =>
      new PatientAllergyControllerApi(getConfigObject()).createPatientAllergy(
        params.patientAllergy,
        params.xTENANTID
      )
  );
